import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";
import { METROPOLITAN_STATISTICAL_AREA, STATES, REGION } from "constants/configItemParents";

export const rows = {
  title: {
    label: "Location",
    isTitle: true
  },
  propertyName: {
    label: "Property Name",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "name",
        variant: "filled",
        multiline: true
      }
    ]
  },
  address: {
    label: "Address",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.STRING, name: "address", label: "Street", hideLabel: true, variant: "filled", style: { width: "100%" } },
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING, name: "city", label: "City", hideLabel: true, variant: "filled", style: { width: "38%", marginLeft: "0", marginTop: "41px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "state",
        name: "stateId",
        variant: "filled",
        parentId: "states",
        label: "State",
        hideLabel: true,
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (id, value) => {
          console.log("onChange", { id });
        },
        style: { width: "35%", marginLeft: "16px", marginTop: "41px" }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "zip",
        label: "Zip",
        hideLabel: true,
        variant: "filled",
        style: { width: "21%", marginTop: "41px" }
      }
    ]
  },
  msa: {
    label: "MSA",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "metropolitanStatisticalArea",
        name: "metropolitanStatisticalAreaId",
        variant: "filled",
        parentId: "msa",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (id, value) => {
          console.log("onChange", { id });
        }
      }
    ]
  },
  region: {
    label: "Region",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "region",
        name: "regionId",
        variant: "filled",
        parentId: "region",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (id, value) => {
          console.log("onChange", { id });
        }

      }
    ]
  }
};
